export default __webpack_public_path__ + "static/packaged_goods-e3e825a3e7293dffe787e0a6e862ffcc.png";